const StatusTrackerTab = () => {
  return (
    <div style={{ height: 'calc(100vh - 310px)' }}></div>
  )
}

export default StatusTrackerTab;